import useSWRV from "swrv";
import { axios, fetcher } from "/@/modules/axios";
import {
  TrainingClient,
  Training,
  TrainingUpdateCheck,
} from "/@/types/training";
import { errorHandle } from "/@/modules/error";
import { ComputedRef, Ref } from "vue";

export function useTrainings() {
  function getTraining(
    id: Ref<number> | ComputedRef<number>,
    option: { withAttachedUrl?: boolean; withWatchedUserNames?: boolean } = {
      withAttachedUrl: true,
      withWatchedUserNames: false,
    }
  ) {
    function getTrainingKey() {
      if (!id || !id.value) return null;

      let uri = `/api/v1/trainings/${id.value}?`;

      if (option.withAttachedUrl) {
        uri += `with_attacthed_url=true`;
      }

      if (option.withWatchedUserNames) {
        uri += `&with_watched_user_names=true`;
      }

      return uri;
    }

    return useSWRV<TrainingClient>(() => getTrainingKey(), fetcher);
  }

  function getTrainings(organizationId: Ref<number> | ComputedRef<number>) {
    function getKey() {
      if (!organizationId || !organizationId.value) return null;
      return `/api/v1/organizations/${organizationId.value}/trainings`;
    }

    return useSWRV<TrainingClient[]>(() => getKey(), fetcher);
  }

  function getSystemAdminTrainings(
    organizationId: Ref<number> | ComputedRef<number>
  ) {
    function getKey() {
      if (!organizationId || !organizationId.value) return null;
      return `/api/v1/users/trainings?organization_id=${organizationId.value}`;
    }

    return useSWRV<TrainingClient[]>(() => getKey(), fetcher);
  }

  async function updateTraining(training: TrainingUpdateCheck) {
    try {
      await axios.patch(`/api/v1/trainings/${training.id}`, {
        trainings: training,
      });
      return true;
    } catch (error) {
      errorHandle(error);
      return false;
    }
  }

  async function createTraining(organizationId: number, training: Training) {
    try {
      await axios.post(`/api/v1/organizations/${organizationId}/trainings`, {
        trainings: training,
      });
      return true;
    } catch (error) {
      alert(errorHandle(error));
      return false;
    }
  }

  async function destroyTraining(id: number) {
    try {
      await axios.delete(`/api/v1/trainings/${id}`);
      return true;
    } catch (error) {
      errorHandle(error);
      return false;
    }
  }

  async function markAsWatched(trainingId: number) {
    try {
      await axios.post(`/api/v1/trainings/${trainingId}/mark_as_watched`);
      return true;
    } catch (e) {
      errorHandle(e);
      return false;
    }
  }

  async function sendWatchedMinutes(id: number, minutes: number) {
    try {
      await axios.post("/api/v1/training_views/update_watch_time", {
        trainingId: id,
        watchedMinutes: minutes,
      });
      // console.log(`📤 Watched ${minutes} minutes sent`);
    } catch (error) {
      console.error("送信失敗:", error);
    }
  }

  return {
    getTraining,
    getTrainings,
    getSystemAdminTrainings,
    createTraining,
    updateTraining,
    destroyTraining,

    markAsWatched,
    sendWatchedMinutes,
  };
}
